import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { Instagram, Mail, MapPin } from 'lucide-react';
const TikTokIcon = ({
  className
}: {
  className?: string;
}) => <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" data-id="element-3769" data-mp="3mh9is9xcwnh3">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.86a8.16 8.16 0 0 0 4.77 1.52V6.93a4.85 4.85 0 0 1-1.84-.24z" data-id="element-3770" data-mp="3hizmtx3t5iuf" />
  </svg>;
const FOOTER_BG = '#172F3D';
const FOOTER_BG_DARK = '#2C4653';
export function SiteFooter() {
  return <footer className="pt-8 pb-5 text-[#E8E4D8]" style={{
    backgroundColor: FOOTER_BG
  }} data-id="element-3771" data-mp="2yk3qog8e2udy">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-3772" data-mp="11q90xzb17xyc">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-6" data-id="element-3773" data-mp="ws7h3c5s7ult">
          {/* Brand Col */}
          <div className="md:col-span-3" data-id="element-3774" data-mp="15qvaj6ksuvid">
            <Link to="/" className="inline-flex items-center gap-3 mb-5" data-id="element-3775" data-mp="15pu094blyd1p">
              <img src="https://cdn.magicpatterns.com/uploads/4gduygJNEAxYz3SyjoFAYx/ChatGPT_Image_May_13,_2026,_09_47_03_PM.png" alt="Structured Nutrition" className="w-14 h-14 object-contain" data-id="element-3776" data-mp="1aqhmzdst07q4" />
              <div className="flex flex-col leading-tight" data-id="element-3777" data-mp="10tv3otg4loq7">
                <span className="text-base font-serif text-white tracking-wide" data-id="element-3778" data-mp="1oieb76rcpxh8">
                  Structured
                </span>
                <span className="text-[10px] font-bold text-white uppercase tracking-[0.25em]" data-id="element-3779" data-mp="1tiisv03zwy91">
                  Nutrition
                </span>
              </div>
            </Link>
            <p className="text-sm text-white leading-relaxed max-w-xs mb-6" data-id="element-3780" data-mp="1jp207zflhp6y">
              Evidence-based nutrition coaching for real, sustainable health.
            </p>
          </div>

          {/* Quick Links Col */}
          <div className="md:col-span-3" data-id="element-3781" data-mp="2c90j8y1cvhr8">
            <h4 className="text-[11px] font-bold text-white uppercase tracking-[0.2em] mb-3" data-id="element-3782" data-mp="2m363lyh9urqp">
              Quick Links
            </h4>
            <ul className="space-y-0.5" data-id="element-3783" data-mp="2h4croahmv8sn">
              {[{
              name: 'About',
              path: '/about'
            }, {
              name: 'Services',
              path: '/services'
            }, {
              name: 'Training',
              path: '/training'
            }, {
              name: 'Books',
              path: '/books'
            }, {
              name: 'Shop',
              path: '/shop'
            }, {
              name: 'Contact',
              path: '/contact'
            }].map(link => <li key={link.name} data-id="element-3784" data-mp="1fehce91ei4qt">
                  <Link to={link.path} className="text-sm text-white hover:text-[#C8C4B0] transition-colors" data-id="element-3785" data-mp="1ffinuembwt92">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Services Col */}
          <div className="md:col-span-3" data-id="element-3786" data-mp="4v4dv8a7no2u">
            <h4 className="text-[11px] font-bold text-white uppercase tracking-[0.2em] mb-3" data-id="element-3787" data-mp="8vy2k3vh96ws">
              Services
            </h4>
            <ul className="space-y-0.5" data-id="element-3788" data-mp="38ce6viaavfpf">
              {['1:1 Nutrition Coaching', 'Personalized Meal Plans', 'Performance Nutrition', 'Strength Training Guidance', 'Supplement Recommendations', 'Accountability Coaching'].map(label => <li key={label} data-id="element-3789" data-mp="2pktsplawz9vj">
                  <Link to="/services" className="text-sm text-white hover:text-[#C8C4B0] transition-colors" data-id="element-3790" data-mp="2pln26u19cdhd">
                    {label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Contact Col */}
          <div className="md:col-span-3" data-id="element-3791" data-mp="25k1wnquq4is0">
            <h4 className="text-[11px] font-bold text-white uppercase tracking-[0.2em] mb-5" data-id="element-3792" data-mp="2k7n0xo3c4o1i">
              Contact
            </h4>
            <div className="flex items-center gap-4" data-id="element-3793" data-mp="2fgn38gme61xy">
              <a href="https://www.tiktok.com/@structured.nutrition" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="text-white hover:text-[#C8C4B0] transition-colors" data-id="element-3794" data-mp="2ff29uubtcp1o">
                <TikTokIcon className="w-5 h-5" data-id="element-3795" data-mp="334esekt169gn" />
              </a>
              <a href="https://www.instagram.com/structured.nutrition" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-white hover:text-[#C8C4B0] transition-colors" data-id="element-3796" data-mp="2y8pq49pmmegn">
                <Instagram className="w-5 h-5" data-id="element-3797" data-mp="3fhrze6owx3u4" />
              </a>
              <Link to="/contact" onClick={() => window.scrollTo(0, 0)} aria-label="Contact" className="text-white hover:text-[#C8C4B0] transition-colors" data-id="element-3798" data-mp="3kfk2zxyx6ee5">
                <Mail className="w-5 h-5" data-id="element-3799" data-mp="3aopeso2454q2" />
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t pt-5 flex flex-col md:flex-row items-center justify-between gap-4" style={{
        borderColor: FOOTER_BG_DARK
      }} data-id="element-3800" data-mp="2wsbtt4ydel6u">
          <p className="text-xs text-white" data-id="element-3801" data-mp="2mu5xd2vc279d">
            © {new Date().getFullYear()} Jack Achenbach, MS, RDN, CPT. All
            rights reserved.
          </p>
          <div className="flex items-center gap-6 text-xs text-white" data-id="element-3802" data-mp="l1q4adnfgb13">
            <Link to="/privacy" onClick={() => window.scrollTo(0, 0)} className="hover:text-white transition-colors" data-id="element-3803" data-mp="q0b4id2oiupj">
              Privacy Policy
            </Link>
            <Link to="/terms" onClick={() => window.scrollTo(0, 0)} className="hover:text-white transition-colors" data-id="element-3804" data-mp="jihopkow92zg">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}